import { Transforms, Element, Text, Node } from 'slate';
import { ReactEditor } from 'slate-react';

// models
import { ElementKind, SlateElementsData } from '../../models/editor.model';

const withAampe = (editor: ReactEditor) => {
    const { normalizeNode, isVoid, isInline, apply } = editor;

    editor.insertText = (text) => {
        Transforms.insertText(editor, text);
    };

    editor.normalizeNode = ([node, path]) => {
        return normalizeNode([node, path]);
    };

    editor.apply = (operation) => {
        if (operation.type === 'move_node') {
            // This is to prevent hitting backspace in a buttonText element taking it out of button element
            const currentNode = Node.get(editor, operation.path);
            if (
                Element.isElement(currentNode) &&
                (currentNode.kind === ElementKind.buttonText ||
                    currentNode.kind === ElementKind.buttonAction)
            )
                return;
        }

        if (
            operation.type === 'remove_node' &&
            Element.isElement(operation.node) &&
            SlateElementsData[operation.node.kind]?.isStaticComponent
        )
            return;

        if (
            operation.type === 'insert_node' &&
            Element.isElement(operation.node) &&
            SlateElementsData[operation.node.kind]?.isStaticComponent
        )
            return;

        if (operation.type === 'merge_node') {
            const node = Node.get(editor, operation.path);
            if (!Text.isText(node))
                // prevent merging of elements other than text.
                return;
        }

        if (operation.type === 'split_node') {
            const currentNode = Node.get(editor, operation.path);
            if (!Text.isText(currentNode))
                // prevent splitting of elements other than text.
                return;
        }

        return apply(operation);
    };

    // tells slate that certain nodes don't have any text content (they're _void_)
    editor.isVoid = (element) => {
        if (Element.isElement(element)) {
            return !!SlateElementsData[element.kind]?.isVoid;
        }
        return isVoid(element);
    };

    // tells slate that certain nodes are inline and should flow with text
    editor.isInline = (element) => {
        if (element.kind in SlateElementsData) {
            return !!SlateElementsData[element.kind]?.isInlineComponent;
        }

        return isInline(element);
    };

    return editor;
};

export default withAampe;
